import { UpdateMessageSetVersion, UpdateMessageSetVersionVariables } from './__generated__/UpdateMessageSetVersion'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation UpdateMessageSetVersion($input: UpdateMessageSetVersionInputV2!) {
    updateMessageSetVersionV2(input: $input) {
      ... on MessageSetVersionErrorV2 {
        type
        error
      }
      ... on MessageSetVersionV2 {
        id
        title
        messageSetId
        messages {
          id
          text
          characters
          createdAt
          tags
          cardSize
        }
      }
    }
  }
`

export const useUpdateMessageSetVersion = () =>
  useMutation<UpdateMessageSetVersion, UpdateMessageSetVersionVariables>(MUTATION)
